import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视分类",
    links: [
      { to: "/category/movie", label: "电影专题" },
      { to: "/category/tv", label: "电视剧库" },
      { to: "/category/variety", label: "综艺频道" },
      { to: "/search", label: "全站搜索" },
    ],
  },
  {
    title: "平台信息",
    links: [
      { to: "/about", label: "关于 97 视频" },
      { to: "/about#contact", label: "联系方式" },
      { to: "/about#terms", label: "服务条款" },
      { to: "/about#usage", label: "使用说明" },
    ],
  },
  {
    title: "友情链接",
    links: [
      { to: "/category/movie", label: "高清电影频道" },
      { to: "/category/tv", label: "热播剧集档案" },
      { to: "/category/variety", label: "影视访谈精选" },
      { to: "/about", label: "合作与反馈" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-secondary-100/70">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">97视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              高清影视视频内容聚合平台，汇聚电影、电视剧、综艺与影视资讯，帮助你更快找到想了解的作品。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-mail-line flex h-4 w-4 items-center justify-center" />
              hello@97video.example
            </p>
          </div>

          <div className="grid flex-1 grid-cols-2 gap-8 sm:grid-cols-3 lg:max-w-2xl">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-label text-[11px] uppercase tracking-[0.18em] text-foreground-500">
                  {col.title}
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-accent-600"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 97视频 · 本站影视资料仅用于内容展示与索引，不提供在线播放服务
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <span className="whitespace-nowrap">内容来源：公开影视资料库</span>
            <span className="hidden h-3 w-px bg-background-400/60 sm:block" />
            <Link to="/about#terms" className="whitespace-nowrap hover:text-accent-600">
              服务声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}